var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedMethod)?_c('div',{staticClass:"text-sm text-neutral-600"},[_c('span',{staticClass:"font-semibold"},[_vm._v(_vm._s(_vm.selectedMethod.label)+":")]),_vm._v(" "+_vm._s(_vm.selectedMethod.description)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }